<template>
  <div class="works-page">
    <!-- 作品类型导航 -->
    <div class="container-box works-nav">
      <div class="index_title index_title1"></div>
      <div class="index_tab_box">
        <div class="index_tab index_tab1 no-active" @click="goToSongWorks"></div>
        <div class="index_tab index_tab2 active" ></div>
      </div>

      <audio-work-rules />
    </div>

    <div class="container-box-wrapper">
      <!-- 作品列表 -->
      <div class="container-box works-list">
        <!-- 页面导航 -->
        <div class="page-nav">
          <router-link to="/audio-works/register" class="page-nav-item tab_1"
            ></router-link
          >
          <router-link to="/audio-works/list" class="page-nav-item tab_2 active"
            ></router-link
          >
        </div>

        <div class="list_tit"></div>
        <ui-list-view
          model="audio-work"
          :thead="thead"
          :tbody="tbody"
          :row-action-config="rowActionConfig"
        ></ui-list-view>
      </div>
    </div>
  </div>
</template>

<script>
import AudioWorkRules from "./Rules.vue";
import workListMixin from "@/mixins/work-list.js";

const getTbody = ({
  registrationFormLabel,
  registrationTypeLabel,
  audioTypeLabel,
}) => [
  {
    field: "applySource",
    class: "auto-br",
    fn: ({ applySource }) => registrationFormLabel[applySource],
  },
  "schoolName",
  {
    field: "applyType",
    fn: ({ applyType }) => registrationTypeLabel[applyType],
  },
  "name",
  {
    field: "audioType",
    fn: ({ audioType }) => audioTypeLabel[audioType],
  },
  {
    field: "title",
    class: "auto-br",
  },
  { slot: "actions" },
];

export default {
  name: "AudioWorksList",
  components: {
    AudioWorkRules,
  },
  mixins: [workListMixin],
  data() {
    const registrationFormLabel = this.$constant.useMap("registrationForm", {
      key: "value",
      value: "label",
    });
    const registrationTypeLabel = this.$constant.useMap("registrationType", {
      key: "value",
      value: "label",
    });
    const audioTypeLabel = this.$constant.useMap("audioType", {
      key: "value",
      value: "label",
    });

    return {
      tbody: getTbody({
        registrationFormLabel,
        registrationTypeLabel,
        audioTypeLabel,
      }),
    };
  },
  methods: {
    goToSongWorks() {
      this.$router.push("/song-works/register");
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/vars";

.works-page {
  margin: 0 auto;
}

.works-nav {
  background: url("@/assets/msg_bg.png") bottom center no-repeat #fff;
  padding: 40px 35px 80px 35px;
  margin-bottom: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.works-type-info {
  text-align: center;
  margin-bottom: 20px;
  position: relative;
}

.works-type-info h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.works-type-info h2.stars::before,
.works-type-info h2.stars::after {
  content: "★★★";
  margin: 0 10px;
}

.works-type-tabs {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
}

.tab {
  border-radius: 20px;
  margin: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab.active {
  background-color: vars.$primary-color;
  color: white;
  cursor: default;
}

.works-rules {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.rule-item {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 5px;
  position: relative;
}

.rule-num {
  position: absolute;
  top: 10px;
  left: 10px;
  color: vars.$primary-color;
  font-weight: bold;
}

.rule-item h3 {
  margin-left: 30px;
  margin-bottom: 10px;
  color: #333;
}

.rule-item p {
  color: #666;
  margin-bottom: 5px;
}

.page-nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
}

.page-nav-item {
  width: 223px;
  height: 51px;
  margin: 0 10px;
  transition: all 0.3s ease;
}

.works-list {
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.works-list h2 {
  text-align: center;
  margin-bottom: 30px;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>